/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Cta_LeadInputs */

const en_hub_cta_lead = /** @type {(inputs: Hub_Cta_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import what you already wrote, let Bystep add acceptance criteria and proof-of-done, then export back into the tool your team lives in.`)
};

const id_hub_cta_lead = /** @type {(inputs: Hub_Cta_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impor yang sudah Anda tulis, biarkan Bystep menambahkan kriteria penerimaan dan bukti selesai, lalu ekspor kembali ke alat yang dipakai tim Anda.`)
};

/**
* | output |
* | --- |
* | "Import what you already wrote, let Bystep add acceptance criteria and proof-of-done, then export back into the tool your team lives in." |
*
* @param {Hub_Cta_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_cta_lead = /** @type {((inputs?: Hub_Cta_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Cta_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_cta_lead(inputs)
	return en_hub_cta_lead(inputs)
});